import {Component} from 'react'

import authentication from './Authentication'
import configuration from '../config'
import { post } from 'jquery'


class AuthenticatedComponent extends Component {
  generateAuthenticatedHeader(addPostHeader) {
    const headerObj = authentication.generateHeaderObject()
    const authenticatedHeaders = new Headers(headerObj)
    if (addPostHeader) {
      authenticatedHeaders.set('Content-Type', 'application/json')
    }
    return authenticatedHeaders
  }


  ////// AHI API CALLS //////

  /// GET BUILDING THERMAL ZONES ///
  getBuildingZoneData(currentBuildingId) {
    if (currentBuildingId) {
      fetch(
        configuration['backend_host'] 
          + '/ahiapi/' + currentBuildingId
          + '/building',
        {
          headers: this.generateAuthenticatedHeader()
        }
      )

      .then(response => response.json())

      .then(data => {
        if (typeof this['successGetBuildingZoneData'] === 'function') {
              this.successGetBuildingZoneData(data)
        }
      })

      .catch(error => console.error(error))
    }
  }

  /// GET SINGLE THERMAL ZONE ///
  getThermalZoneSummary(currentZoneId) {
    if (currentZoneId) {
      fetch(
        configuration['backend_host'] 
          + '/ahiapi/' + currentZoneId
          + '/thermalZone',
        {
          headers: this.generateAuthenticatedHeader()
        }
      )

      .then(response => response.json())

      .then(data => {
        if (typeof this['zoneSummaryCallback'] === 'function') {
          this.zoneSummaryCallback(data)
        }
      })

      .catch(error => console.error(error))
    }
  }



  /// GET COMFORT DATA ///
  getComfortData(currentCampusId) {
    if (currentCampusId) {
      fetch(
        configuration['backend_host'] 
          + '/ahiapi/' + currentCampusId
          + '/campus/comfort',
        {
          headers: this.generateAuthenticatedHeader()
        }
      )

      .then(response => response.json())

      .then(data => {
        if (typeof this['successGetComfortData'] === 'function') {
              this.successGetComfortData(data)
        }
      })

      .catch(error => console.error(error))
    }
  }



  /// GET ENERGY DATA ///
  getEnergyData(currentCampusId, energyCallback) {
    if (currentCampusId) {
      fetch(
        configuration['backend_host'] 
          + '/ahiapi/' + currentCampusId
          + '/campus/energy',
        {
          headers: this.generateAuthenticatedHeader()
        }
      )

      .then(response => response.json())

      .then(data => {
        energyCallback(data)
      })

      .catch(error => console.error(error))
    }
  }



  /// GET SCHEDULES DATA ///
  getScheduleData(currentCampusId, level, scheduleCallback) {
    if (currentCampusId) {
      fetch(
        configuration['backend_host'] 
          + '/ahiapi/' + currentCampusId
          + '/schedules/' + level,
        {
          headers: this.generateAuthenticatedHeader()
        }
      )

      .then(response => response.json())

      .then(data => {
        scheduleCallback(data)
      })

      .catch(error => console.error(error))
    }
  }



  /// GET SELECTED SCHEDULE DATA ///
  getSelectedScheduleData(currentCampusId, scheduleId, selectedCallback) {
    if (currentCampusId) {
      fetch(
        configuration['backend_host'] 
          + '/ahiapi/' + currentCampusId
          + '/schedule/' + scheduleId,
        {
          headers: this.generateAuthenticatedHeader()
        }
      )

      .then(response => response.json())

      .then(data => {
        selectedCallback(data)
      })

      .catch(error => console.error(error))
    }
  }



  /// GET SCHEDULE ASSIGNMENTS ///
  getScheduleAssignments(currentCampusId, assignmentCallback) {
    if (currentCampusId) {
      fetch(
        configuration['backend_host'] 
          + '/ahiapi/' + currentCampusId
          + '/schedules/assignments',
        {
          headers: this.generateAuthenticatedHeader()
        }
      )

      .then(response => response.json())

      .then(data => {
        Object.entries(data).forEach(([key, buildings]) => {
          assignmentCallback(buildings)
        })
      })

      .catch(error => console.error(error))
    }
  }



  /// GET EVENTS LIST ///
  getEventsList(currentCampusId, eventsCallback) {
    if (currentCampusId) {
      fetch(
        configuration['backend_host'] 
          + '/ahiapi/' + currentCampusId
          + '/events',
        {
          headers: this.generateAuthenticatedHeader()
        }
      )

      .then(response => response.json())

      .then(data => {
        eventsCallback(data)
      })

      .catch(error => console.error(error))
    }
  }



  /// GET EVENTS ASSIGNMENT LIST ///
  getEventAssignmentList(currentCampusId, eventsAssignmentCallback) {
    if (currentCampusId) {
      fetch(
        configuration['backend_host'] 
          + '/ahiapi/' + currentCampusId
          + '/events/possibleAssignments',
        {
          headers: this.generateAuthenticatedHeader()
        }
      )

      .then(response => response.json())

      .then(data => {
        eventsAssignmentCallback(data)
      })

      .catch(error => console.error(error))
    }
  }



   /// USER PROFILE ///
  getUserProfile(successCallback) {
    fetch(configuration['backend_host'] + '/prefs/' + authentication.getUserId(),
    {
      headers: this.generateAuthenticatedHeader()
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Request failed')
        }
        return response.json()
      })

      .then(data => {
        successCallback(data)
      })

      .catch(data => {
        successCallback({
          id: authentication.getUserId(),
          'prefs': {}
        })
      })
  }

  initiateUserProfile(updatedValues, successCallback) {
    // get the latest version of the user profile
    this.getUserProfile(this.saveUserProfile.bind(this, updatedValues, successCallback))
  }

  saveUserProfile(updatedValues, successCallback, postData) {
    Object.assign(postData['prefs'], updatedValues)
    fetch(configuration['backend_host'] + '/prefs/' + authentication.getUserId(),
    {
      headers: this.generateAuthenticatedHeader(true),
      method: 'POST',
      body: JSON.stringify(postData)
    })

    .then(data => {
      if (successCallback) {
        successCallback(data)
      }
    })
  }


  /// ZONE SETTINGS ///
  getOverrideData() {
    const { currentCampusData } = this.props;

    if (currentCampusData) {
    fetch(
      configuration['backend_host'] + '/schedule/'
        + currentCampusData['entityKey']['organizationCode']
        + '/' + currentCampusData['entityKey']['campusCode']
        + '/scheduledOverrides' +  '.json',
      {
        headers: this.generateAuthenticatedHeader()
      }
    )
      .then(response => response.json())
      .then(data => {
        return data;
      })
    }
  }

  saveDemandExSettings(zoneData, postData) {
    // Send data to the backend via POST
    fetch(configuration['backend_host'] + '/command/'
    + zoneData['entityKey']['organizationCode']
    + '/' + zoneData['entityKey']['campusCode']
    + '/' + zoneData['entityKey']['buildingIndex']
    + '/' + zoneData['entityKey']['thermalZoneIndex']
    + '/profile', 
    {
      headers: this.generateAuthenticatedHeader(true),
      method: 'POST', 
      body: JSON.stringify(postData)
    })

    .then(response => {
      response.json()
      // if (response.ok) {
      //   console.log(response)
      // }
    })
    .then(data => data)
  }

  saveOverrideZoneSettings() {
    
  }
}

export default AuthenticatedComponent